import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/constants";

export default function Testimonials() {
  const split = Math.ceil(TESTIMONIALS.length / 2);
  const row1 = TESTIMONIALS.slice(0, split);
  const row2 = TESTIMONIALS.slice(split);

  return (
    <section className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 text-center">
        <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
          Trusted by 10,000+
        </div>
        <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-slate-900" data-testid="testimonials-title">
          Real users. Real cash-outs. Real fast.
        </h2>
      </div>

      <div className="relative space-y-4">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-slate-50 to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-slate-50 to-transparent z-10 pointer-events-none" />
        <Marquee speed={28} pauseOnHover gradient={false}>
          {row1.concat(row1).map((t, i) => <TestimonialCard key={`a-${i}`} t={t} index={i} />)}
        </Marquee>
        <Marquee speed={28} direction="right" pauseOnHover gradient={false}>
          {row2.concat(row2).map((t, i) => <TestimonialCard key={`b-${i}`} t={t} index={i} />)}
        </Marquee>
      </div>
    </section>
  );
}

function TestimonialCard({ t, index }) {
  return (
    <div
      className="mx-3 w-[340px] sm:w-[400px] rounded-2xl border border-slate-200 bg-white p-6 hover:border-[#3B6FBF]/40 hover:shadow-sm transition-all"
      data-testid={`testimonial-${index}`}
    >
      <div className="flex items-center gap-1 mb-3">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} className="w-3.5 h-3.5 fill-[#3B6FBF] text-[#3B6FBF]" />
        ))}
      </div>
      <p className="text-sm text-slate-700 leading-relaxed">"{t.body}"</p>
      <div className="mt-4 text-xs text-slate-500 font-mono-data">{t.handle}</div>
    </div>
  );
}
